import React from 'react';
import { Link } from 'react-router-dom';
import ROUTES from '../routes.json';
import { normalizeRoute } from '../utils/routeHelpers';

const PrivacyPolicy = () => {
  return (
    <div style={{padding:24}}>
      <h1 className="page-title">Privacy Policy</h1>
      <p>Last updated: {new Date().toISOString().split('T')[0]}</p>

      <p>OneAI ("we", "us", "our") takes your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our website and services.</p>

      <h3>Information we collect</h3>
      <ul>
        <li>Account information you provide when signing in (name, email, profile picture via Google OAuth).</li>
        <li>Content you submit to our tools (text you paste for humanization or blog drafts).</li>
        <li>Usage data such as logs, timestamps, and API usage metrics.</li>
      </ul>

      <h3>How we use information</h3>
      <ul>
        <li>To provide and maintain our services.</li>
        <li>To process payments and manage subscriptions (we use Razorpay as our payment processor — see our Payment Policy).</li>
        <li>To improve features, monitor performance, and detect abuse.</li>
      </ul>

      <h3>Third-party services</h3>
      <p>We use third-party services to deliver the Site and its features. These providers (including Razorpay for payments) have their own privacy practices — please refer to their policies for details. Razorpay privacy: https://razorpay.com/privacy/</p>

      <h3>Data retention</h3>
      <p>We retain data as necessary to provide services, comply with legal obligations, and enforce our agreements.</p>

      <h3>Your choices</h3>
      <p>You may request access, correction, or deletion of your personal data by contacting us at info.onehubtech@gmail.com.</p>

      <h3>Contact</h3>
      <p>For privacy concerns: info.onehubtech@gmail.com</p>

      <div style={{ marginTop: 20 }}>
        <h4>Explore more</h4>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Link to={normalizeRoute(ROUTES.humanizer.path)} className="btn ghost">Try the Humanizer</Link>
          <Link to={normalizeRoute(ROUTES.blog.path)} className="btn ghost">Visit our Blog</Link>
          <Link to={normalizeRoute(ROUTES.contact.path)} className="btn ghost">Contact Us</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
